import { useState } from 'react';
import dayjs from 'dayjs';
import { faBolt, faClockRotateLeft, faCommentSms, faNoteSticky, faPhoneVolume, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useThreadQuery } from '../../queries/messages';
import { useAgentShortName } from '../../queries/agents';
import { useAddClientNote } from '../../queries/clients';
import { Btn, I, Seg } from '../Todos/ui';
import { Lrow } from './parts';

const FILTERS = [
  ['all', 'All'],
  ['call', 'Calls'],
  ['text', 'Texts'],
  ['note', 'Notes']
];
const ICON = { call: faPhoneVolume, text: faCommentSms, note: faNoteSticky, action: faBolt };
const stamp = (d) => (d ? dayjs(d).format('MMM D, h:mm A') : '');

function NoteBox({ id }) {
  const [t, setT] = useState('');
  const add = useAddClientNote(id);
  const save = () => {
    if (!t.trim()) return;
    add.mutate(t.trim());
    setT('');
  };
  return (
    <div className="m-row gap8">
      <input
        className="m-inp sm grow"
        placeholder="Add a note for the team"
        value={t}
        maxLength={240}
        onChange={(e) => setT(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && save()}
        aria-label="Add a note"
      />
      <Btn sm icon={faPlus} disabled={!t.trim()} onClick={save}>
        Add note
      </Btn>
    </div>
  );
}

export default function Activity({ c, data, done, onCall }) {
  const [f, setF] = useState('all');
  const agent = useAgentShortName();
  const { data: thread } = useThreadQuery(c.phone);
  const first = String(c.name || '').split(' ')[0];
  const calls =
    c.kind === 'owner'
      ? (data.calls || []).map((k) => ({
          kind: 'call',
          at: k.startedAt,
          title: `${k.direction === 'outbound' ? 'Outbound' : 'Inbound'} call`,
          text: k.summary || k.outcome || '',
          open: () => onCall(k._id)
        }))
      : (data.history || []).filter((h) => h.kind === 'call').map((h) => ({ kind: 'call', at: h.at, title: h.label, text: h.text }));
  const texts = (thread?.messages || []).map((m) => ({
    kind: 'text',
    at: m.createdAt,
    title: `Text · ${m.direction === 'inbound' ? first : m.sentByUserId ? 'Team' : agent}`,
    text: m.body
  }));
  const notes =
    c.kind === 'client'
      ? (data.client.noteThread || []).map((n) => ({ kind: 'note', at: n.createdAt, title: `Note · ${n.by || 'Team'}`, text: n.text }))
      : c.kind === 'vendor' && data.vendor.notes
        ? [{ kind: 'note', at: data.vendor.updatedAt, title: 'Note', text: data.vendor.notes }]
        : [];
  const actions = done.map((x) => ({ kind: 'action', at: x.resolvedAt || x.updatedAt, title: 'Agent Actions', text: x.title }));
  const all = [...calls, ...texts, ...notes, ...actions].sort((a, b) => new Date(b.at || 0) - new Date(a.at || 0));
  const show = all.filter((a) => f === 'all' || a.kind === f);
  return (
    <div className="m-col gap12">
      <div className="m-row wrap gap8">
        <Seg items={FILTERS} value={f} onChange={setF} label="Show" />
      </div>
      {c.kind === 'client' && <NoteBox id={c.id} />}
      {show.length ? (
        <div className="cp-feed">
          {show.map((a, i) => (
            <Lrow
              key={`${a.kind}-${a.at}-${i}`}
              icon={ICON[a.kind]}
              title={
                <span className="m-row gap8">
                  <span>{a.title}</span>
                  <span className="m-sub">{stamp(a.at)}</span>
                </span>
              }
              sub={a.text}
              clamp
              onClick={a.open}
            />
          ))}
        </div>
      ) : (
        <div className="m-emptyc">
          <div className="m-emi">
            <I icon={faClockRotateLeft} />
          </div>
          <div className="b">No activity yet.</div>
        </div>
      )}
    </div>
  );
}
